body:has(.form-login) {
  background-color: #f5f5f5;
}

.login-error {
  max-width: 35rem;
  margin: 2rem auto;
  margin-bottom: 0;
}

.form-login {
  margin: 40px auto;
  max-width: 330px;
  padding: 15px;
}

.form-login .form-floating:focus-within {
  z-index: 2;
}

.form-login input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-login input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
